export default {
  bold: ["far", "bold"],
  italic: ["far", "italic"],
  underline: ["far", "underline"],
  link: ["far", "link"],
  bulletList: ["far", "list-ul"],
  orderedList: ["far", "list-ol"],
  calendarDay: ["far", "calendar-day"],
  checkCircle: ["fas", "check-circle"],
  email: ["fas", "envelope"],
  mobile: ["fas", "mobile-alt"],
  microsoftTeams: ["fac", "microsoft-teams"],
  search: ["far", "search"],
  home: ["fas", "home"],
  // slack: ["fab", "slack"],
  breadcrumbDivider: ["fas", "chevron-right"],
  groupBreadcrumb: ["far", "layer-group"],
  breadcrumbAngle: ["far", "angle-right"],
  lock: ["fas", "lock"],
  pen: ["fas", "pencil"],
  plus: ["fas", "plus"],
  peopleRoof: ["far", "people-roof"],
  externalLink: ["far", "external-link"],
  exclamation: ["fas", "exclamation-circle"],
  exclamationTriangle: ["fas", "exclamation-triangle"],
  information: ["fas", "info"],
  infoCircle: ["fas", "info-circle"],
  invite: ["fas", "paper-plane"],

  // externalLink: ["fas", "external-link-alt"],
  save: ["fas", "save"],
  check: ["fas", "check"],
  cancel: ["fas", "times"],
  undo: ["far", "undo"],
  copy: ["fas", "copy"],
  copied: ["fas", "clipboard-check"],
  // arrowUp: ["fas", "arrow-up"],
  // exclamationTriangle: ["fas", "exclamation-triangle"],
  // sitemap: ["fas", "sitemap"],
  // loading: ["fas", "circle-notch"],
  // comments: ["far", "comment-dots"],
  trash: ["far", "trash-alt"],
  back: ["far", "angle-left"],
  chevronUp: ["fas", "chevron-up"],
  chevronDown: ["fas", "chevron-down"],

  // Used in code for flags
  skip: ["fas", "forward"],
  vcpu: ["fas", "microchip"],
  memory: ["fas", "memory"],
  executionTimeout: ["fas", "clock"],
  force: ["fas", "exclamation-triangle"],
  canary: ["fas", "flask"],
  logLevel: ["fas", "file-alt"],
  nodeAllocatedMemory: ["fas", "server"],
  disabled: ["fas", "ban"],
  directions: {
    n: ["fas", "left-right"],
    p: ["fas", "long-arrow-alt-left"],
    c: ["fas", "long-arrow-alt-right"],
  },
};
